import { render, staticRenderFns } from "./OResourceAllocation.vue?vue&type=template&id=82368602&scoped=true&"
import script from "./OResourceAllocation.vue?vue&type=script&lang=js&"
export * from "./OResourceAllocation.vue?vue&type=script&lang=js&"
import style0 from "./OResourceAllocation.vue?vue&type=style&index=0&id=82368602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82368602",
  null
  
)

export default component.exports